import axios from "axios";

export const sendMintMail = (price, nTokens, email) => {
  axios
    .post("/mint-mail", {
      price,
      quantity: nTokens,
      email,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log({ err });
    });
};
